import React, { useState, useRef } from 'react';
import IconPng from 'atoms/IconPng';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory,
{
  PaginationProvider,
  PaginationTotalStandalone,
  SizePerPageDropdownStandalone,
  PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import {
  TableBottomRow,
  TableTopRow,
  TableMainWrapper,
  SizeWrapper,
  SearchWrapper,
  AltWrapper,
  LeftSection,
  RightSection,
  StyledSpan
} from './styles';
import { withTheme } from 'styled-components';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const btnIcons = {
  ic_plus: require('App/assets/images/ic_plus.png'),
  ic_search: require('App/assets/images/ic_search.png')
}

const rowStyle = { overflowWrap: 'break-word' }

const SearchInput = props => (
  <SearchWrapper {...props}>
    {props.isInline ?
      null :
      <>Search: &emsp;</>
    }
    <input
      className="form-control"
      style={{ width: (props.isInline ? '100%' : props.isMobile ? '55%' : '70%'), height: '36px', fontSize: '12px' }}
      onChange={e => props.onSearch(e.target.value)}
      type="text"
    />
  </SearchWrapper>
)

const DataTables = props => {
  const {
    dataList,
    columnConfig,
    theme,
    leftSlot,
    selectConfig,
    noStripe,
    noHeadings,
    rightSlotAlt,
    allowAdd,
    allowSearch = true,
    isDbClick,
    isInlineEdit,
    defaultSorted,
    defaultSize,
    fnEdit,
    fnAdd,
    isMobile,
    minWidth,
    expandRow,
    containerClassName,
    sizePerPage = 7,
    sizePerPageList = [7, 10, 25, 30, 50, 100],
    onSizePerPageChange,
    onSearch
  } = props
  const [isSearch, toggleSearch] = useState(false)
  const triggerEl = useRef(null);

  const paginationTotalRenderer = (from, to, size) => (
    <StyledSpan>
      Showing {from} to {to} of {size} entries
    </StyledSpan>
  );

  const sizePerPageOptionRenderer = ({
    text,
    page,
    onSizePerPageChange
  }) => (
      <li
        key={text}
        role="presentation"
        className="dropdown-item"
      >
        <div
          tabIndex="-1"
          role="menuitem"
          data-page={page}
          onMouseDown={(e) => {
            e.preventDefault();
            onSizePerPageChange(page);
          }}
          style={{ color: 'black' }}
        >
          {text}
        </div>
      </li>
    );

  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const buttonStyle = {
      backgroundColor: 'transparent',
      border: 'none',
      outline: 0
    };
    const activeStyle = {};
    const activeBtn = {};
    if (active) {
      activeBtn.backgroundColor = theme.mocaPurple;
      activeStyle.color = 'white';
      activeStyle.fontWeight = 'bold';
      activeBtn.borderRadius = '50%';
      activeBtn.width = '34px';
      activeBtn.height = '34px';
      activeBtn.display = 'flex';
      activeBtn.flexDirection = 'column';
      activeBtn.justifyContent = 'center';
      activeBtn.alignItems = 'center';
    } else {
      activeStyle.backgroundColor = theme.white;
      activeStyle.color = '#9a9a9a';
      activeBtn.width = '34px';
      activeBtn.height = '34px';
      activeBtn.display = 'flex';
      activeBtn.flexDirection = 'column';
      activeBtn.justifyContent = 'center';
      activeBtn.alignItems = 'center';
    }
    if (typeof page === 'string') {
      activeStyle.backgroundColor = 'white';
      activeStyle.color = theme.mocaPurple;
      activeStyle.fontWeight = '600';
    }
    return (
      <li className="page-item" style={activeBtn} key={page}>
        <button onClick={handleClick} style={{ ...buttonStyle, ...activeStyle }}>{page}</button>
      </li>
    );
  };

  const options = {
    custom: true,
    totalSize: dataList.length,
    firstPageText: 'First',
    prePageText: 'Prev',
    nextPageText: 'Next',
    lastPageText: 'Last',
    sizePerPage: defaultSize ? defaultSize : sizePerPage,
    sizePerPageList,
    pageButtonRenderer,
    paginationTotalRenderer,
    sizePerPageOptionRenderer,
    onSizePerPageChange
  };

  return (
    <PaginationProvider
      pagination={paginationFactory(options)}
    >
      {
        ({ paginationProps, paginationTableProps }) => (
          <TableMainWrapper
            containerClassName={containerClassName}
            minWidth={minWidth}
          >
            <ToolkitProvider
              keyField="id"
              data={dataList}
              columns={columnConfig}
              search
            >
              {
                props => (
                  <>
                    {!noHeadings &&
                      <TableTopRow>
                        {leftSlot &&
                          <LeftSection>
                            {!isSearch ? leftSlot : <SearchInput isInline={true} {...props.searchProps} />}
                          </LeftSection>
                        }
                        <RightSection>
                          {rightSlotAlt ?
                            <React.Fragment>
                              <AltWrapper>
                                {allowSearch &&
                                  <IconPng srcIcon={btnIcons.ic_search} onClick={() => toggleSearch(!isSearch)} showPointer={true} />
                                }
                                {allowAdd &&
                                  <IconPng srcIcon={btnIcons.ic_plus} onClick={() => fnAdd()} showPointer={true} />
                                }
                              </AltWrapper>
                            </React.Fragment> :
                            <React.Fragment>
                              <SizeWrapper>
                                Show &emsp;
                              <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                                &emsp; entries
                          </SizeWrapper>
                              <SearchInput {...props.searchProps} {...onSearch ? { onSearch } : {}} isMobile={isMobile} />
                            </React.Fragment>
                          }
                        </RightSection>
                      </TableTopRow>
                    }
                    <BootstrapTable
                      noDataIndication="Table is Empty"
                      bordered={false}
                      striped={noStripe ? false : true}
                      hover
                      selectRow={selectConfig ? selectConfig : undefined}
                      defaultSorted={defaultSorted ? defaultSorted : undefined}
                      ref={triggerEl}
                      rowStyle={rowStyle}
                      cellEdit={isInlineEdit && fnEdit ?
                        cellEditFactory({
                          mode: isDbClick ? 'dbClick' : 'click',
                          // onStartEdit: (row, column, rowIndex, columnIndex) => { console.log('start to edit!!!'); },
                          beforeSaveCell: fnEdit.before,
                          afterSaveCell: fnEdit.after
                        }) :
                        undefined}
                      expandRow={expandRow}
                      {...props.baseProps}
                      {...paginationTableProps}
                    />
                  </>
                )
              }
            </ToolkitProvider>
            {!rightSlotAlt &&
              <TableBottomRow>
                <PaginationTotalStandalone {...paginationProps} />
                <PaginationListStandalone {...paginationProps} />
              </TableBottomRow>
            }
          </TableMainWrapper>
        )
      }
    </PaginationProvider>
  )
}

const wrappedComp = withTheme(DataTables);
export {
  wrappedComp as default,
  DataTables
}
